import React from 'react';
import { StoreHeadline } from './store-headline';
import { AddressAndOpeningHours } from './address-and-opening-hours';
import { ReturnForm } from './return-form';
import directionUrl from '../store/direction-url';

export function Store({store, storeIndex, origin, postcode, retailers, isMobileDevice, showMobileStoreDetail, selected, handleMobileThumbnailClicked, toggleExpandedStore, isInPostStoreLocatorRebrandEnabled}) {
  let direction_url = null;
  if (origin && store) {
    direction_url = directionUrl(origin, store);
  }

  const storeAddress = (store) =>
    `${store.address || ''}, ${store.city || ''}, ${store.county ? store.county + ',' : ''} ${store.postcode || ''}`
  ;

  return (
    <li className='store-list-element selected'>
      <StoreHeadline
        name={store.name}
        distance={store.distance}
        store={store}
        directionUrl={direction_url}
        store_id={store.id}
        index={storeIndex}
        isMobileDevice={isMobileDevice}
        thumbnail_url={store.store_image_thumb_url}
        showMobileStoreDetail={showMobileStoreDetail}
        handleMobileThumbnailClicked={handleMobileThumbnailClicked}
        address={storeAddress(store)}
        selectedStore={selected}
        toggleExpandedStore={toggleExpandedStore}
        isInPostStoreLocatorRebrandEnabled={isInPostStoreLocatorRebrandEnabled}
      />

      <div className="store-details -yodel">
        <AddressAndOpeningHours
          store={store}
          address={storeAddress(store)}
          showMobileStoreDetail={showMobileStoreDetail}
          isMobileDevice={isMobileDevice}
          selectedStore={selected}
          isInPostStoreLocatorRebrandEnabled={isInPostStoreLocatorRebrandEnabled}
        />

        {(!isMobileDevice || (isMobileDevice && !selected)) &&
          <ReturnForm
            directionUrl={direction_url}
            retailers={retailers}
            postcode={postcode}
            store={store}
            isMobileDevice={isMobileDevice}
          />
        }
      </div>
    </li>
  );
}
